// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/tornado.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/tornado/tornado.js';

mount([g0]);
